import { Facet } from '../models/Facet';
import { IOperationActionCreator } from '../store/actions/implementOperation';
import { ProgressKeyFacet, implementOperationWithProgress } from './progress';

export const deleteItemsOperation = new Facet<{}>('deleteItems');

export const deleteProgressKeyFacet = new ProgressKeyFacet<typeof deleteItemsOperation.type>('deleteItems');

export const deleteItems: IOperationActionCreator<typeof deleteItemsOperation.type> = implementOperationWithProgress({
  operationTypeFacet: deleteItemsOperation,
  progressKeyFacet: deleteProgressKeyFacet
});
